import React from 'react';
import { motion } from 'framer-motion';
import { Award, ShieldCheck, HeartHandshake } from 'lucide-react';
import { Link } from 'react-router-dom';
const features = [{
  icon: Award,
  stat: '25+ Years',
  title: 'Experience',
  description: 'Decades of dedicated service in providing premium, compassionate healthcare to our community.'
}, {
  icon: ShieldCheck,
  stat: '100%',
  title: 'Certified Staff',
  description: 'Our team consists of rigorously trained, fully licensed, and deeply empathetic professionals.'
}, {
  icon: HeartHandshake,
  stat: 'Tailored',
  title: 'Care Plans',
  description: 'We understand every individual is unique. Your care plan is designed specifically around your needs.'
}];
export function WhyChooseUs() {
  return <section id="about" className="py-24 bg-nude" data-id="element-203">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-204">
        <div className="grid lg:grid-cols-12 gap-12 items-center" data-id="element-205">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="lg:col-span-5" data-id="element-206">
            <h2 className="text-4xl md:text-5xl font-serif text-chocolate mb-6" data-id="element-207">
              Why Families Trust <br data-id="element-208" />
              <span className="italic text-chocolate/80" data-id="element-209">Crownehealth</span>
            </h2>
            <p className="text-lg text-chocolate/80 mb-8 leading-relaxed" data-id="element-210">
              Choosing the right healthcare partner is a profound decision. We
              honor that trust by delivering an exceptional standard of care
              that prioritizes human connection, clinical excellence, and
              absolute transparency.
            </p>
            <Link to="/about" className="inline-flex items-center gap-2 text-chocolate font-bold border-b-2 border-gold pb-1 hover:text-gold transition-colors" data-id="element-211">
              Meet Our Care Team
            </Link>
          </motion.div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-6" data-id="element-212">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.15
          }} className={`bg-white rounded-3xl p-8 shadow-soft ${index === 2 ? 'sm:col-span-2 sm:w-1/2 sm:mx-auto' : ''}`} data-id="element-213">
                <div className="w-12 h-12 rounded-full bg-nude-light flex items-center justify-center text-gold mb-6" data-id="element-214">
                  <feature.icon size={24} data-id="element-215" />
                </div>
                <div className="text-3xl font-serif font-bold text-chocolate mb-2" data-id="element-216">
                  {feature.stat}
                </div>
                <h3 className="text-lg font-bold text-chocolate mb-3 uppercase tracking-wider text-sm" data-id="element-217">
                  {feature.title}
                </h3>
                <p className="text-chocolate/70 text-sm leading-relaxed" data-id="element-218">
                  {feature.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}